<!-- MyMenu.vue -->
<template>
  <v-menu >
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" class="w-100">
        Configure {{
          type === 'command' ? 'Command' :
          type === 'aggregate' ? 'Aggregate Root' :
          type === 'read model' ? 'Read Model' :
          'default'
        }} card type
      </v-btn>
    </template>
    <v-list density="compact" width="200">
      <v-list-item style="user-select: none;">
        <b v-if="type === 'aggregate'"><small>Select Aggregate Root card type:</small></b>
        <b v-if="type === 'command'"><small>Select Command card type:</small></b>
        <b v-if="type === 'read model'"><small>Select Read Model card type:</small></b>
        <b v-if="type === 'default'"><small>Select Default card type:</small></b>
        <!-- <b><small>Select Action card type:</small></b> -->
        <!-- <b>Select a card type to be used for Aggregates</b> -->
      </v-list-item>
      <v-list-item v-for="item in menuItems" :key="item.id" @click="selectItem(item)">
        <v-list-item-title>
          <v-avatar :color="item?.color?.rgb || 'gray'" size="18" class="card-type-color mr-2"></v-avatar>
          <span class="card-type-title">{{ item.title }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="createNewCardType()">
        <v-list-item-title class="no-color">
          Create new card type
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import requirementTypesApi from '@/api/requirementTypesApi'
import { EventBus } from '@/event-bus/event-bus.js'

export default {
  props: {
    requirementTypes: Array,
    type: String
  },

  computed: {
    menuItems () {
      if (!this.requirementTypes) return []
      return this.requirementTypes.filter(item => !item.triggerType && !item.queryType && !item.aggregateType)
    }
  },

  methods: {
    async selectItem (item) {
      const newItem = JSON.parse(JSON.stringify(item))
      newItem.queryType = newItem.triggerType = newItem.aggregateType = false
      if (this.type === 'command') {
        newItem.triggerType = true
      } else if (this.type === 'read model') {
        newItem.queryType = true
      } else if (this.type === 'aggregate') {
        newItem.aggregateType = true
      } else {
        newItem.defaultType = true
      }
      newItem.showInBacklog = !(newItem.triggerType || newItem.queryType || newItem.aggregateType)
      await requirementTypesApi.updateRequirementType(this.$route.params.id, newItem)
      await this.$store.dispatch('workflow/refreshCardTypes', { input: { workflowId: this.$route.params.id } })
    },

    createNewCardType () {
      EventBus.$emit('open-settings', true)
    }
  }
}
</script>

<style scoped>
.card-type-title {
  vertical-align: middle;
}

.no-color {
  margin-left: 26px;
}
</style>
